import React from "react";
import { useInView } from "../hooks";

// Fades/slides children in when scrolled into view. `delay` is in ms.
function Reveal({ as: Tag = "div", delay = 0, dir = "up", className = "", children, ...rest }) {
  const [ref, seen] = useInView();
  return (
    <Tag
      ref={ref}
      className={`reveal reveal-${dir} ${seen ? "in" : ""} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export default Reveal;
